import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

import { AccountBackend } from '@libs/src/account/account.backend';
import { ToastService } from '@libs/src/toast/toast.service';

import { Account } from '@libs/src/models/account.model';
import { SetUser } from '@libs/src/user/user.actions';
import { IAppState } from '@main-client/src/app/app.state';
import { headlineWidgetConfig } from '@main-client/src/app/profile-completion-widget-view/profile-completion-widget-configs';
import { LoadProfile } from '@main-client/src/app/profile/profile-store/profile.actions';

@Component({
  selector: 'app-profile-form-dialog-headline',
  templateUrl: './profile-form-dialog-headline.component.html',
})
export class ProfileFormDialogHeadlineComponent implements OnInit {
  user: Account;
  description = headlineWidgetConfig.description;
  title = headlineWidgetConfig.title;
  formGroup: UntypedFormGroup;
  isLoading = false;
  update = { short_bio: '' };

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { user: Account },
    private dialogRef: MatDialogRef<ProfileFormDialogHeadlineComponent>,
    private accountBackend: AccountBackend,
    private store: Store<IAppState>,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.user = this.data.user;
  }

  closeDialog(update: any) {
    this.dialogRef.close(update);
  }

  formChange(update: { short_bio: string }) {
    this.update = update;
  }

  save(update: { short_bio: string }, user: Account) {
    this.isLoading = true;
    this.accountBackend
      .patchAccount(update)
      .pipe(
        tap(({ data }: { data: Account }) => {
          const updatedProfile = {
            ...user,
            ...data,
          };
          this.store.dispatch(SetUser(data));
          this.store.dispatch(LoadProfile(updatedProfile));
          this.closeDialog(data);
        }),
        catchError((response: HttpErrorResponse) => {
          this.toastService.showError(response.error.message);
          return EMPTY;
        }),
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe();
  }
}
